/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { Select } from 'ember-power-select/components/power-select';

interface CreateEventTriggerDataSidebarItemSelectTriggerArgs {
  select: Select;
  extra: { labelProperty?: string };
}

export default class CreateEventTriggerDataSidebarItemSelectTrigger extends Component<CreateEventTriggerDataSidebarItemSelectTriggerArgs> {}
